import React from "react";

// NexTech "N" mark, paths taken from nextechz.com
// Colours: --brand-logo-dark / --brand-logo-accent in src/index.css
function NexTechLogo({
  size = 34,
  dark = "var(--brand-logo-dark)",
  accent = "var(--brand-logo-accent)",
  className = "",
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="NexTech"
    >
      <path
        d="M25.6865 24.2789L12.5288 16.6824V22.9044L30.4107 33.2283V4.47778H25.6865V24.2789Z"
        fill={accent}
      />
      <path
        d="M3.58838 0.763184V29.5141H8.31261V9.71298L21.4699 17.3095V11.0875L3.58838 0.763184Z"
        fill={dark}
      />
    </svg>
  );
}

export default NexTechLogo;
